
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutItemsSelectGrid extends _Ext.GridBase<BranchOutItemsRow,any> {
        protected getColumnsKey() { return 'Inventory.BranchOutItemsSelect'; }
        protected getDialogType() { return <any>BranchOutItemsDialog; }
        protected getIdProperty() { return BranchOutItemsRow.idProperty; }
        protected getLocalTextPrefix() { return BranchOutItemsRow.localTextPrefix; }
        protected getInitialTitle() { return null; };
        //protected getInsertPermission() { return BranchOutItemsRow.insertPermission; }
        //protected getUpdatePermission() { return BranchOutItemsRow.updatePermission; }
        //protected getDeletePermission() { return BranchOutItemsRow.deletePermission; }
        //protected useViewMode() { return true; } 
        //static ledgerId: number; 
        //static ItemType: number;
       

        constructor(container: JQuery, options) {
            super(container, options);             
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
 
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): BranchOutItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}